import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';

const TableIcon = ({ className }) => (
  <SvgIcon viewBox='0 0 174 168' className={className}>
    <defs>
      <clipPath id='clip-path'>
        <circle
          id='Ellipse_11'
          data-name='Ellipse 11'
          cx='84'
          cy='84'
          r='84'
          transform='translate(3455 3269)'
          fill='#fff'
          stroke='#707070'
          strokeWidth='1'
        />
      </clipPath>
      <clipPath id='clip-path-2'>
        <rect width='297' height='59' fill='none' />
      </clipPath>
      <clipPath id='clip-path-3'>
        <rect width='143' height='59' fill='none' />
      </clipPath>
    </defs>
    <ellipse
      id='Ellipse_10'
      data-name='Ellipse 10'
      cx='80.5'
      cy='80'
      rx='80.5'
      ry='80'
      transform='translate(13 4)'
      fill='#f3f8fd'
    />
    <rect
      id='Rectangle_70670'
      data-name='Rectangle 70670'
      width='111'
      height='26'
      rx='6'
      transform='translate(0 40)'
      fill='#ddeefd'
    />
    <g id='Mask_Group_2' data-name='Mask Group 2' transform='translate(-3449 -3269)' clipPath='url(#clip-path)'>
      <g id='Group_1555' data-name='Group 1555'>
        <rect
          id='Rectangle_70671'
          data-name='Rectangle 70671'
          width='320'
          height='26'
          rx='6'
          transform='translate(3449 3309)'
          fill='#ddeefd'
        />
        <g
          id='Rectangle_70672'
          data-name='Rectangle 70672'
          transform='translate(3455 3315)'
          fill='#fff'
          stroke='#a2c2e3'
          strokeWidth='1'
        >
          <rect width='14' height='14' rx='4' stroke='none' />
          <rect x='0.5' y='0.5' width='13' height='13' rx='3.5' fill='none' />
        </g>
        <rect
          id='Rectangle_70673'
          data-name='Rectangle 70673'
          width='10'
          height='10'
          rx='5'
          transform='translate(3479 3317)'
          fill='#a2c2e3'
        />
        <rect
          id='Rectangle_70674'
          data-name='Rectangle 70674'
          width='68'
          height='10'
          rx='3'
          transform='translate(3499 3317)'
          fill='#a2c2e3'
        />
        <rect
          id='Rectangle_70675'
          data-name='Rectangle 70675'
          width='49'
          height='10'
          rx='3'
          transform='translate(3580 3317)'
          fill='#a2c2e3'
        />
        <rect
          id='Rectangle_70676'
          data-name='Rectangle 70676'
          width='48'
          height='10'
          rx='3'
          transform='translate(3642 3317)'
          fill='#a2c2e3'
        />
        <rect
          id='Rectangle_70677'
          data-name='Rectangle 70677'
          width='49'
          height='10'
          rx='3'
          transform='translate(3703 3317)'
          fill='#a2c2e3'
        />
        <g id='Repeat_Grid_10' data-name='Repeat Grid 10' transform='translate(3455 3338)' clipPath='url(#clip-path-2)'>
          <g id='Group_1552' data-name='Group 1552' transform='translate(-1091 -331)'>
            <g
              id='Rectangle_70678'
              data-name='Rectangle 70678'
              transform='translate(1091 331)'
              fill='#fff'
              stroke='#a2c2e3'
              strokeWidth='1'
            >
              <rect width='14' height='14' rx='4' stroke='none' />
              <rect x='0.5' y='0.5' width='13' height='13' rx='3.5' fill='none' />
            </g>
            <rect
              id='Rectangle_70679'
              data-name='Rectangle 70679'
              width='10'
              height='10'
              rx='5'
              transform='translate(1115 333)'
              fill='#a2c2e3'
            />
            <rect
              id='Rectangle_70680'
              data-name='Rectangle 70680'
              width='68'
              height='10'
              rx='3'
              transform='translate(1135 333)'
              fill='#a2c2e3'
            />
            <rect
              id='Rectangle_70681'
              data-name='Rectangle 70681'
              width='49'
              height='10'
              rx='3'
              transform='translate(1216 333)'
              fill='#a2c2e3'
            />
            <rect
              id='Rectangle_70682'
              data-name='Rectangle 70682'
              width='48'
              height='10'
              rx='3'
              transform='translate(1278 333)'
              fill='#a2c2e3'
            />
            <rect
              id='Rectangle_70683'
              data-name='Rectangle 70683'
              width='49'
              height='10'
              rx='3'
              transform='translate(1339 333)'
              fill='#a2c2e3'
            />
          </g>
          <g id='Group_1553' data-name='Group 1553' transform='translate(-1091 -311)'>
            <g
              id='Rectangle_70684'
              data-name='Rectangle 70684'
              transform='translate(1091 331)'
              fill='#fff'
              stroke='#a2c2e3'
              strokeWidth='1'
            >
              <rect width='14' height='14' rx='4' stroke='none' />
              <rect x='0.5' y='0.5' width='13' height='13' rx='3.5' fill='none' />
            </g>
            <rect
              id='Rectangle_70685'
              data-name='Rectangle 70685'
              width='10'
              height='10'
              rx='5'
              transform='translate(1115 333)'
              fill='#a2c2e3'
            />
            <rect
              id='Rectangle_70686'
              data-name='Rectangle 70686'
              width='68'
              height='10'
              rx='3'
              transform='translate(1135 333)'
              fill='#a2c2e3'
            />
            <rect
              id='Rectangle_70687'
              data-name='Rectangle 70687'
              width='49'
              height='10'
              rx='3'
              transform='translate(1216 333)'
              fill='#a2c2e3'
            />
            <rect
              id='Rectangle_70688'
              data-name='Rectangle 70688'
              width='48'
              height='10'
              rx='3'
              transform='translate(1278 333)'
              fill='#a2c2e3'
            />
            <rect
              id='Rectangle_70689'
              data-name='Rectangle 70689'
              width='49'
              height='10'
              rx='3'
              transform='translate(1339 333)'
              fill='#a2c2e3'
            />
          </g>
          <g id='Group_1554' data-name='Group 1554' transform='translate(-1091 -291)'>
            <g
              id='Rectangle_70690'
              data-name='Rectangle 70690'
              transform='translate(1091 331)'
              fill='#fff'
              stroke='#a2c2e3'
              strokeWidth='1'
            >
              <rect width='14' height='14' rx='4' stroke='none' />
              <rect x='0.5' y='0.5' width='13' height='13' rx='3.5' fill='none' />
            </g>
            <rect
              id='Rectangle_70691'
              data-name='Rectangle 70691'
              width='10'
              height='10'
              rx='5'
              transform='translate(1115 333)'
              fill='#a2c2e3'
            />
            <rect
              id='Rectangle_70692'
              data-name='Rectangle 70692'
              width='68'
              height='10'
              rx='3'
              transform='translate(1135 333)'
              fill='#a2c2e3'
            />
            <rect
              id='Rectangle_70693'
              data-name='Rectangle 70693'
              width='49'
              height='10'
              rx='3'
              transform='translate(1216 333)'
              fill='#a2c2e3'
            />
            <rect
              id='Rectangle_70694'
              data-name='Rectangle 70694'
              width='48'
              height='10'
              rx='3'
              transform='translate(1278 333)'
              fill='#a2c2e3'
            />
            <rect
              id='Rectangle_70695'
              data-name='Rectangle 70695'
              width='49'
              height='10'
              rx='3'
              transform='translate(1339 333)'
              fill='#a2c2e3'
            />
          </g>
        </g>
        <use id='Image_3' data-name='Image 3' transform='translate(3553 3318)' xlinkHref='#image' />
      </g>
    </g>
    <g id='Group_1556' data-name='Group 1556' transform='translate(-3449 -3269)'>
      <g
        id='Rectangle_70662'
        data-name='Rectangle 70662'
        transform='translate(3455 3315)'
        fill='#fff'
        stroke='#a2c2e3'
        strokeWidth='1'
      >
        <rect width='14' height='14' rx='4' stroke='none' />
        <rect x='0.5' y='0.5' width='13' height='13' rx='3.5' fill='none' />
      </g>
      <rect
        id='Rectangle_70661'
        data-name='Rectangle 70661'
        width='10'
        height='10'
        rx='5'
        transform='translate(3479 3317)'
        fill='#a2c2e3'
      />
      <g id='Repeat_Grid_9' data-name='Repeat Grid 9' transform='translate(3455 3338)' clipPath='url(#clip-path-3)'>
        <g id='Group_1551' data-name='Group 1551' transform='translate(-1091 -331)'>
          <g
            id='Rectangle_70669'
            data-name='Rectangle 70669'
            transform='translate(1091 331)'
            fill='#fff'
            stroke='#a2c2e3'
            strokeWidth='1'
          >
            <rect width='14' height='14' rx='4' stroke='none' />
            <rect x='0.5' y='0.5' width='13' height='13' rx='3.5' fill='none' />
          </g>
          <rect
            id='Rectangle_70668'
            data-name='Rectangle 70668'
            width='10'
            height='10'
            rx='5'
            transform='translate(1115 333)'
            fill='#a2c2e3'
          />
          <rect
            id='Rectangle_70664'
            data-name='Rectangle 70664'
            width='68'
            height='10'
            rx='3'
            transform='translate(1135 333)'
            fill='#a2c2e3'
          />
          <rect
            id='Rectangle_70665'
            data-name='Rectangle 70665'
            width='49'
            height='10'
            rx='3'
            transform='translate(1216 333)'
            fill='#a2c2e3'
          />
          <rect
            id='Rectangle_70666'
            data-name='Rectangle 70666'
            width='48'
            height='10'
            rx='3'
            transform='translate(1278 333)'
            fill='#a2c2e3'
          />
          <rect
            id='Rectangle_70667'
            data-name='Rectangle 70667'
            width='49'
            height='10'
            rx='3'
            transform='translate(1339 333)'
            fill='#a2c2e3'
          />
        </g>
        <g id='Group_1551-2' data-name='Group 1551' transform='translate(-1091 -311)'>
          <g
            id='Rectangle_70669-2'
            data-name='Rectangle 70669'
            transform='translate(1091 331)'
            fill='#fff'
            stroke='#a2c2e3'
            strokeWidth='1'
          >
            <rect width='14' height='14' rx='4' stroke='none' />
            <rect x='0.5' y='0.5' width='13' height='13' rx='3.5' fill='none' />
          </g>
          <rect
            id='Rectangle_70668-2'
            data-name='Rectangle 70668'
            width='10'
            height='10'
            rx='5'
            transform='translate(1115 333)'
            fill='#a2c2e3'
          />
          <rect
            id='Rectangle_70664-2'
            data-name='Rectangle 70664'
            width='68'
            height='10'
            rx='3'
            transform='translate(1135 333)'
            fill='#a2c2e3'
          />
          <rect
            id='Rectangle_70665-2'
            data-name='Rectangle 70665'
            width='49'
            height='10'
            rx='3'
            transform='translate(1216 333)'
            fill='#a2c2e3'
          />
          <rect
            id='Rectangle_70666-2'
            data-name='Rectangle 70666'
            width='48'
            height='10'
            rx='3'
            transform='translate(1278 333)'
            fill='#a2c2e3'
          />
          <rect
            id='Rectangle_70667-2'
            data-name='Rectangle 70667'
            width='49'
            height='10'
            rx='3'
            transform='translate(1339 333)'
            fill='#a2c2e3'
          />
        </g>
        <g id='Group_1551-3' data-name='Group 1551' transform='translate(-1091 -291)'>
          <g
            id='Rectangle_70669-3'
            data-name='Rectangle 70669'
            transform='translate(1091 331)'
            fill='#fff'
            stroke='#a2c2e3'
            strokeWidth='1'
          >
            <rect width='14' height='14' rx='4' stroke='none' />
            <rect x='0.5' y='0.5' width='13' height='13' rx='3.5' fill='none' />
          </g>
          <rect
            id='Rectangle_70668-3'
            data-name='Rectangle 70668'
            width='10'
            height='10'
            rx='5'
            transform='translate(1115 333)'
            fill='#a2c2e3'
          />
          <rect
            id='Rectangle_70664-3'
            data-name='Rectangle 70664'
            width='68'
            height='10'
            rx='3'
            transform='translate(1135 333)'
            fill='#a2c2e3'
          />
          <rect
            id='Rectangle_70665-3'
            data-name='Rectangle 70665'
            width='49'
            height='10'
            rx='3'
            transform='translate(1216 333)'
            fill='#a2c2e3'
          />
          <rect
            id='Rectangle_70666-3'
            data-name='Rectangle 70666'
            width='48'
            height='10'
            rx='3'
            transform='translate(1278 333)'
            fill='#a2c2e3'
          />
          <rect
            id='Rectangle_70667-3'
            data-name='Rectangle 70667'
            width='49'
            height='10'
            rx='3'
            transform='translate(1339 333)'
            fill='#a2c2e3'
          />
        </g>
      </g>
      <use id='Image_2' data-name='Image 2' transform='translate(3553 3318)' xlinkHref='#image' />
    </g>
  </SvgIcon>
);

export default TableIcon;
